export const OCPP_VERSION_201 = 'ocpp2.0.1';
export const OCPP_VERSION_16 = 'ocpp1.6';
